import { HeadingPitchRange } from "cesium";
import React, { useContext } from "react";
import { Cesium1Set, RendouSet, Rotate1Set, SyukurenSet } from "../App";

export const ButtonFlytohome = (props) => {
  const { setRotate1Set } = useContext(Rotate1Set);
  const { setRendouSet } = useContext(RendouSet);
  const { setSyukurenSet } = useContext(SyukurenSet);
  const { cesium1set } = useContext(Cesium1Set);

  const flytohome = () => {
    setRendouSet(false);
    setSyukurenSet(false);
    setRotate1Set(false);
    cesium1set.current.cesiumElement.flyTo(
      cesium1set.current.cesiumElement.entities,
      new HeadingPitchRange(0, -1, 50000)
    );
  };

  return (
    <>
      <main className="flex items-center justify-center m-2">
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 pointer-events-auto"
          x-data="app"
        >
          <input
            name="rotate"
            id="ホーム"
            type="checkbox"
            // value="ホーム"
            onChange={flytohome}
            checked={false}
            className="peer hidden"
          />
          <label
            htmlFor="ホーム"
            className="block cursor-pointer select-none md:rounded-xl md:px-3 md:py-2 text-center text-xs md:text-base peer-checked:bg-blue-500 peer-checked:text-white"
          >
            <div className="z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
            </div>
          </label>
        </div>
      </main>
    </>
  );
};
